// WelcomeComponent.js
import React from "react";
import { Button, Flex, Header } from "@fluentui/react-northstar";
import { useMsal } from "@azure/msal-react";
import { Navigate } from "react-router-dom";
import Illustration from "./reportingIllustration";

const styles = {
  illust: {
    height: "350px",
  },
};

function Welcome() {
  const { instance, accounts } = useMsal();

  const isLogged = accounts.length > 0;

  const handleLogin = async () => {
    try {
      await instance.loginRedirect({
        scopes: ["User.Read", "openid", "profile", "email", "offline_access"],
      });
    } catch (error) {
      console.error("Login failed:", error);
    }
  };

  if (isLogged) {
    return <Navigate to="/ReportsList" />;
  }

  return (
    <Flex column>
      <Flex hAlign="center" vAlign="center">
        <Header as="h1" content="Welcome to Heedify Reports Page" />
      </Flex>
      <Flex hAlign="center" vAlign="center">
        <Illustration style={styles.illust} />
      </Flex>
      <Flex hAlign="center" vAlign="center">
        <Button
          icon={<MsIcon />}
          content="Sign in with Microsoft"
          secondary
          onClick={handleLogin}
        />
      </Flex>
    </Flex>
  );

  function MsIcon(props) {
    return (
      <svg viewBox="0 0 512 512" height="100%" width="100%" {...props}>
        <path d="M496 0H272v240h240V16c0-8.832-7.168-16-16-16zM16 0C7.168 0 0 7.168 0 16v224h240V0H16zM0 272v224c0 8.832 7.168 16 16 16h224V272H0zM272 272v240h224c8.832 0 16-7.168 16-16V272H272z" />
      </svg>
    );
  }
}

export default Welcome;
